import React, { useEffect } from "react";
import { StyleProp, ViewStyle } from "react-native";
import { EventRegister } from "react-native-event-listeners";
import { CallDataRow } from "src/components";
import { navigationRef } from "src/hooks";
import LocalText from "src/local";

export type CommentProps = {
  containerStyle?: StyleProp<ViewStyle>;
  value?: string;
  onChange: (value?: string) => void;
};

export const Comment: React.FC<CommentProps> = ({
  containerStyle,
  value,
  onChange,
}) => {
  const eventName = "CallCommentEvent";
  useEffect(() => {
    const listener = EventRegister.addEventListener(eventName, (v: string) => {
      onChange(v.length > 0 ? v : undefined);
    });
    return () => {
      EventRegister.removeEventListener(listener as string);
    };
  }, [onChange]);
  return (
    <CallDataRow
      containerStyle={containerStyle}
      leftIcon={"comment"}
      text={value ? value : LocalText.screens.call.comment.placeholder}
      rightIcon={"chevron"}
      onPress={() => {
        navigationRef.current?.navigate("CustomTextEdit", {
          eventName: eventName,
          title: LocalText.screens.call.comment.comment,
          placeholder: LocalText.screens.call.comment.comment,
          text: value,
          isMultiline: true,
        });
      }}
    />
  );
};
